import {
	DASHBOARD_FILTERS_SECTION_DAID,
	DASHBOARD_ISSUES_FILTERS_SECTION_DAID
} from 'data-automation-ids/DashboardAutomationIds';

export const DASHBOARD_TEMPLATE_FILTER_PRESETS = {
	dashboard: {
		ariaLabel: 'Dashboard filters',
		skipLinkId: 'dashboard-filters-section',
		dataAutomationId: DASHBOARD_FILTERS_SECTION_DAID,
		hasTextFilter: false,
		forceRemountOnFilterChange: true
	},
	issues: {
		ariaLabel: 'Issues filters',
		skipLinkId: 'issues-filters-section',
		dataAutomationId: DASHBOARD_ISSUES_FILTERS_SECTION_DAID,
		hasTextFilter: true,
		forceRemountOnFilterChange: true
	}
} as const;
